module.exports = __webpack_public_path__ + "img/온리프_로고.f15f852e.jpg";